import { getShapePathById } from '../../../../../Canvas/CanvasStateSelectors';

const getAssignedStyles = (fabricShape, canvasState) => canvasState.getIn(
    [...getShapePathById(canvasState, fabricShape.id), 'assignedStyles']
);

export default getAssignedStyles;
